var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap login-wrap"},[_vm._m(0),_c('div',{staticClass:"bnb-btn"},[_c('button',{staticClass:"active",on:{"click":function($event){return _vm.showApp()}}},[_vm._v("앱 열기")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrap"},[_c('img',{staticClass:"w-270px",attrs:{"src":require("@/assets/img/logo_coach.png"),"alt":"better and better"}})])
}]

export { render, staticRenderFns }